import { useQuery } from "react-query";
import type { ApiError } from "@/react/config/CustomErrors";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { CssVariables } from "./constants";

interface ThemeOption {
  cssVariables: CssVariables;
  id: string;
  value: string;
}

interface RawThemeData {
  css_variables: CssVariables;
  value: string;
}

export const useGetThemes = () =>
  useQuery<RawThemeData[], ApiError, ThemeOption[]>({
    queryKey: ["themes"],
    queryFn: () => reactQueryGet(internalApi.settings.sites.themes.index()),
    select: (data: RawThemeData[]) =>
      data.map(theme => ({
        id: theme.value,
        value: theme.value,
        cssVariables: theme.css_variables,
      })),
    staleTime: 1000 * 60 * 60 * 24,
  });
